import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  CVIS_OPTIONS,
  HEADER_VALUES,
  ROW_VALUES,
} from './customer-location-setting.constants';

@Component({
  selector: 'app-customer-location-setting',
  templateUrl: './customer-location-setting.component.html',
  styleUrl: './customer-location-setting.component.scss',
  standalone: false,
})
export class CustomerLocationSettingComponent {
  @Input() form!: FormGroup;

  readonly HEADERS = HEADER_VALUES;
  readonly TABLE_DATA = ROW_VALUES;
  readonly OPTIONS = CVIS_OPTIONS;
}
